// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Rs-z","tooltipWrapper":"Ss-z","icon":"Ts-z","tooltip":"Us-z","content":"Vs-z"};